import SignUpTemp from "./signupcomponents/signuptemp";

function Signup(){
    return(
        <>
            <SignUpTemp />
        </>
    )
}

export default Signup;